import { z } from 'zod';
import { toIso } from './util';

export const SALES_ORDER_STATUSES = ['confirmed', 'in_production', 'ready', 'shipped'] as const;

export const SalesOrderSchema = z
  .object({
    id: z.string(),
    soNum: z.string(),
    poNumber: z.string().optional(),
    customerId: z.string().nullable().optional(),
    customerName: z.string().optional(),
    skus: z.array(z.string()),
    selectedQty: z.union([z.string(), z.number()]).optional(),
    skuCount: z.number().optional(),
    total: z.number(),
    status: z.string(),
    estimatedShipDate: z.string().optional(),
    poRequiredDate: z.string().optional(),
    createdAt: z.string().optional(),
    updatedAt: z.string().optional(),
  })
  .passthrough();

export type SalesOrder = z.infer<typeof SalesOrderSchema>;

export interface NewSalesOrderOptions {
  id: string;
  soNum: string;
  total?: number;
  status?: string;
  customerId?: string | null;
  customerName?: string;
  now?: Date | string;
}

/** Build a fresh sales order with sane defaults (confirmed, $0, no SKUs). */
export function newSalesOrder(opts: NewSalesOrderOptions): SalesOrder {
  const ts = toIso(opts.now);
  const so: SalesOrder = {
    id: opts.id,
    soNum: opts.soNum,
    customerId: opts.customerId ?? null,
    skus: [],
    total: opts.total ?? 0,
    status: opts.status ?? 'confirmed',
    createdAt: ts,
    updatedAt: ts,
  };
  if (opts.customerName !== undefined) so.customerName = opts.customerName;
  return so;
}
